import React, {Component} from 'react';
import './footer.scss';
import {NavLink} from "react-router-dom";
import footer from './../../assets/footer/footer.png';



class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {};

    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    // shouldComponentUpdate() {
    //
    // }

    render() {
        const {navTree, cur_pathname} = this.state;

        return (
           <footer>
               <img src={footer} alt=""/>
           </footer>
        );
    }


}

export default Footer;


// WEBPACK FOOTER //
// ./src/pages/Index/index.js
